// import { LocalStorage, Notify } from 'quasar'
import { LocalStorage } from 'quasar'
import { getCurrentPosition } from 'src/utils/utils'

const state = {
  serverErrorMsg: null,
  savedGeolocation: LocalStorage.getItem('geolocation') || null,
  geolocation: null
}

const mutations = {
  SET_SERVER_ERROR_MSG (state, msg = null) {
    state.serverErrorMsg = msg
  },
  SET_GEOLOCATION_COORDINATES (state, payload = null) {
    (payload)
      ? LocalStorage.set('geolocation', payload)
      : LocalStorage.remove('geolocation')
    state.geolocation = payload
  }
}

const actions = {
  setGeolocationCoordinates ({ commit }, payload) {
    commit('SET_GEOLOCATION_COORDINATES', payload)
  },
  mineGeolocationCoordinates ({ commit }, payload) {
    console.log('mineGeolocationCoordinates START')
    return getCurrentPosition({ maximumAge: 1000 * 60 * 10, timeout: 1000 * 10 })
      .then(
        (pos) => {
          console.log('mineGeolocationCoordinates SUCCESS', pos)
          let crd = pos.coords
          commit('SET_GEOLOCATION_COORDINATES', {
            lat: crd.latitude,
            long: crd.longitude
          })
          return pos
        },
        (err) => {
          console.error('ERROR:', err.message)
          // Notify.create({
          //   color: 'negative',
          //   message: `Sorry, but the following error occurred: ${err.message}`,
          //   icon: 'report_problem',
          //   position: 'bottom',
          //   timeout: 4000
          // })
          return err
        }
      )
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
